'use client'
import { ROUTES } from '@constants/paths'
import { SessionProvider } from 'next-auth/react'

export default function SessionContext({ children }: { children: React.ReactNode }) {
  return <SessionProvider basePath={ROUTES.AUTH}>{children}</SessionProvider>
}
